import { FormControl } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';
import { NgbDateRange } from '../../../../utils/date-helper/date-helper.util';

export enum PLNewRequestAdditionalControlName {
  Place = 'place',
  Street = 'street',
  AreaToLease = 'areaToLease',
  Comments = 'comments',
  LeaseDate = 'leaseDate',
  Purpose = 'purpose',
  AnexDateFrom = 'anexDateFrom',
  AnexDescription = 'anexDescription',
  LeaseNumber = 'leaseNumber',
}

export const PLNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...PLNewRequestAdditionalControlName,
};

export interface PLNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [PLNewRequestControlName.Place]: FormControl<string>;
  [PLNewRequestControlName.Street]: FormControl<string>;
  [PLNewRequestControlName.AreaToLease]: FormControl<string>;
  [PLNewRequestControlName.Comments]: FormControl<string>;
  [PLNewRequestControlName.LeaseDate]: FormControl<NgbDateRange>;
  [PLNewRequestControlName.Purpose]: FormControl<string>;
  [PLNewRequestControlName.AnexDateFrom]: FormControl<NgbDate>;
  [PLNewRequestControlName.AnexDescription]: FormControl<string>;
  [PLNewRequestControlName.LeaseNumber]: FormControl<string>;
}
